import {
  UsageExplorerTopItem,
  UsageGroupByType,
} from "@shared/types/localTypes/usage-explorer.ts";
import { ConsumptionCsvGroupBy } from "@shared/services/usage-explorer/fetchConsumptionCsv.ts";
import { TourConsumptionRow } from "@shared/types/localTypes/tour.ts";

type ToTourConsumptionTopItem = (args: {
  readonly row: TourConsumptionRow;
  readonly groupBy: ConsumptionCsvGroupBy;
}) => UsageExplorerTopItem;

const toTourConsumptionTopItem: ToTourConsumptionTopItem = ({
  row,
  groupBy,
}) => {
  const values = [
    row.trafficBytes + row.storageBytes,
    row.trafficBytes,
    row.storageBytes,
  ];
  if (groupBy === UsageGroupByType.TECHNICAL_SERVER_NAME) {
    return [row.name, ...values];
  }
  return [row.name, ...values, row.jpd];
};

export default toTourConsumptionTopItem;
